import { onMounted, ref, onUnmounted, type ComponentPublicInstance, computed, type Ref, unref } from 'vue';

export function onElementIntersect(
    target: Ref<HTMLElement | ComponentPublicInstance | null>,
    options: IntersectionObserverInit = { root: null, rootMargin: '0px' }
) {
    const intersectionRatio = ref(0);
    const isIntersecting = ref(false);
    const isFullyInView = ref(false);
    const isReadyIntersection = ref(false);
    const element = computed(() => {
        const e = unref(target);
        if (e instanceof HTMLElement) {
            return e;
        } else if (e instanceof Object) {
            return (e ).$el;
        } else {
            return null;
        }
    });

    function observe() {
        if (element.value) {
            observer.observe(element.value);
        }
    }

    let observer: IntersectionObserver;
    onMounted(() => {
        if (!('IntersectionObserver' in window)) return;

        observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                intersectionRatio.value = entry.intersectionRatio;
                if (entry.intersectionRatio > 0) {
                    isIntersecting.value = true;
                    isFullyInView.value = entry.intersectionRatio >= 1;
                    return;
                }

                isIntersecting.value = false;
            });

            isReadyIntersection.value = true;
        }, options);

        observe();
    });

    function unobserve() {
        if (!observer) return;

        if (element.value) {
            observer.unobserve(element.value);
        }
    }

    onUnmounted(unobserve);

    return {
        intersectionRatio,
        isIntersecting,
        isFullyInView,
        isReadyIntersection,
        observe,
        unobserve,
    };
}
